import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import { media } from '../../../../styles/base';

const styles = makeStyles((theme: Theme) =>
  createStyles({
    advancedContent: {
      backgroundColor: 'white',
    },
    advancedFilters: {
      height: '100%',
      borderRadius: 10,
      backgroundColor: 'white',
    },
    buttonClose: {
      height: 24,
      width: 24,
      position: 'absolute',
      right: 24,
      zIndex: 10,
    },
    content: {
      borderRadius: 10,
      display: 'flex',
      flexDirection: 'column',
      padding: '24px 0px',
      position: 'relative',
      zIndex: 100,
    },
    closeIcon: {
      height: 24,
      width: 24,
    },
    essentialContent: {
      backgroundColor: 'white',
    },
    filterControls: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'space-between',
      margin: '0px 24px',
      marginTop: 'auto',
    },
    filterHeader: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'center',
      margin: '0px 16px 12px 16px',
      position: 'relative',
    },
    filterHeading: {
      fontWeight: 700,
      fontSize: 21,
      lineHeight: '25.2px',
    },
    filterNavigation: {
      margin: '15px 16px',
    },
    filterPage: {
      marginBottom: 24,
      padding: '0px 24px',
      [media.mobile]: {
        padding: '0px 16px',
      },
    },
    filterSeparator: {},
    filterSeparator1: {
      display: 'flex',
      justifyContent: 'space-between',
      padding: '0 20px 10px',
    },
    filterSeparatorWithDivider: {},
    personalizeContent: {
      backgroundColor: 'white',
      padding: '16px',
    },
    personalizeFilterContainer: {
      margin: '24px 0px',
      width: '100%',
      display: 'flex',
      flexWrap: 'wrap',
    },
    personalizeHeader: {
      color: '#323232',
      fontSize: 18,
      fontWeight: 700,
      lineHeight: '24px',
    },
    personalizeHeading: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
    personalizeSubHeader: {
      color: '#555555',
      fontSize: 18,
      lineHeight: '21.6px',
      [media.mobile]: {
        fontSize: 14,
      },
    },
    resetAndShare: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      width: '50%',
    },
    resetButton: {
      borderRadius: 0,
      padding: 0,
    },
    resetButtonText: {
      fontSize: '18px',
      fontWeight: 500,
      letterSpacing: 2.24,
      lineHeight: '24px',
      textTransform: 'capitalize',
    },
    room: {
      paddingLeft: 5,
      fontSize: 16,
      textTransform: 'none',
    },
    roomContainer: {
      alignItems: 'center',
      borderRadius: 18,
      borderStyle: 'solid',
      cursor: 'pointer',
      display: 'flex',
      height: 40,
      justifyContent: 'center',
      margin: 5,
      padding: '8px',
    },
    roomSelected: {
      fontSize: 12,
      fontWeight: 'bold',
      backgroundColor: '#463264',
      color: '#FFFFFF',
      lineHeight: '16.8px',
      width: 18,
      height: 18,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: 9,
      textTransform: 'none',
    },
    submitButton: {
      backgroundColor: '#463264',
      color: '#FFFFFF',
      fontSize: '18px',
      fontWeight: 'bold',
      height: '56px',
      letterSpacing: 2.25,
      lineHeight: '24px',
      textAlign: 'center',
      textTransform: 'capitalize',
      width: 165,
    },
    submitButtonContainer: {
      width: '50%',
      display: 'flex',
      justifyContent: 'flex-end',
    },
    roomConditionContainer: {
      height: 'auto',
      overflow: 'hidden',
      overflowY: 'scroll',
      '&::-webkit-scrollbar': {
        display: 'none',
      },
    },
    roomQualityButton: {
      alignItems: 'center',
      borderStyle: 'solid',
      cursor: 'pointer',
      display: 'flex',
      height: 40,
      justifyContent: 'center',
      margin: 0,
      padding: '8px',
      borderRadius: 0,
      backgroundColor: '#FFFFFF',
      borderColor: '#555555',
      borderWidth: 1,
      '&:hover': {
        backgroundColor: '#FFFFFF',
      },
    },
    roomQualityButtonText: {
      color: '#55555',
      fontSize: 16,
      textTransform: 'none',
    },
    selectedQuality: {
      backgroundColor: '#463264',
      '&:hover': {
        backgroundColor: '#463264',
      },
    },
    selectedText: {
      color: '#FFFFFF',
      fontSize: 16,
      fontWeight: 'bold',
      textTransform: 'none',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    bedandbathFilterTitle: {
      color: '#323232',
      fontSize: 18,
      fontWeight: 'bold',
      lineHeight: '21.6px',
    },
  }),
);

export default styles;
